"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { EntityDisplay, NumberStepper } from "fansunited-sports-ui";
import { TeamLogo } from "@/components/ui/TeamLogo";
import type { TeamDisplayData } from "./TeamDisplay";

/** EntityDisplay styles for home team on desktop (name left, logo right → toward center) */
const homeTeamStylesLg = {
  imageSize: "3xl" as const,
  typography: {
    name: "text-(--background-text-color) font-semibold text-xl text-right"
  }
};

/** EntityDisplay styles for away team on desktop (logo left → toward center, name right) */
const awayTeamStylesLg = {
  imageSize: "3xl" as const,
  typography: {
    name: "text-(--background-text-color) font-semibold text-xl"
  }
};

/** EntityDisplay styles for mobile (inline, smaller) */
const teamStylesSm = {
  imageSize: "xl" as const,
  typography: {
    name: "text-(--background-text-color) font-semibold text-base"
  }
};

/** NumberStepper styles for desktop */
const stepperStylesLg = {
  button: "text-(--background-text-color-muted) hover:text-(--background-text-color) bg-white/10 hover:bg-white/20 border-0 transition-colors w-full",
  value: "text-3xl font-bold text-gray-900",
  valueContainer: "w-16 h-14 bg-white rounded-lg shadow-lg"
};

/** NumberStepper styles for mobile */
const stepperStylesSm = {
  button: "text-(--background-text-color-muted) hover:text-(--background-text-color) bg-white/10 hover:bg-white/20 border-0 transition-colors h-10",
  value: "text-2xl font-bold text-gray-900",
  valueContainer: "w-12 h-10 bg-white rounded-lg shadow-lg"
};
interface PredictionFormProps {
  team: TeamDisplayData;
  opponent: TeamDisplayData;
  homeScore: string;
  awayScore: string;
  isSubmitting: boolean;
  hasError: boolean;
  gradientFrom: string;
  gradientTo: string;
  onIncrementScore: (which: "home" | "away") => void;
  onDecrementScore: (which: "home" | "away") => void;
  onBack: () => void;
  onSubmit: (e: React.FormEvent) => void;
  labels: {
    formTitle: string;
    predictionError: string;
    backButton: string;
    submitButton: string;
    submitting: string;
  };
}
export const PredictionForm: React.FC<PredictionFormProps> = t0 => {
  const $ = _c(79);
  const {
    team,
    opponent,
    homeScore,
    awayScore,
    isSubmitting,
    hasError,
    gradientFrom,
    gradientTo,
    onIncrementScore,
    onDecrementScore,
    onBack,
    onSubmit,
    labels
  } = t0;
  const homeVal = parseInt(homeScore || "0");
  const awayVal = parseInt(awayScore || "0");
  let t1;
  if ($[0] !== homeVal || $[1] !== onDecrementScore || $[2] !== onIncrementScore) {
    t1 = newVal => {
      if (newVal > homeVal) {
        onIncrementScore("home");
      } else {
        if (newVal < homeVal) {
          onDecrementScore("home");
        }
      }
    };
    $[0] = homeVal;
    $[1] = onDecrementScore;
    $[2] = onIncrementScore;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleHomeChange = t1;
  let t2;
  if ($[4] !== awayVal || $[5] !== onDecrementScore || $[6] !== onIncrementScore) {
    t2 = newVal_0 => {
      if (newVal_0 > awayVal) {
        onIncrementScore("away");
      } else {
        if (newVal_0 < awayVal) {
          onDecrementScore("away");
        }
      }
    };
    $[4] = awayVal;
    $[5] = onDecrementScore;
    $[6] = onIncrementScore;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleAwayChange = t2;
  let t3;
  if ($[8] !== labels.formTitle) {
    t3 = <div className="text-center mb-6"><h3 className="text-xl sm:text-3xl font-bold text-(--background-text-color)">{labels.formTitle}</h3></div>;
    $[8] = labels.formTitle;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = team.shortName || team.name;
  const t5 = team.assets?.logo;
  let t6;
  if ($[10] !== t5) {
    t6 = <TeamLogo src={t5} size="xl2" />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <EntityDisplay name={t4} image={t6} imagePosition="right" styles={homeTeamStylesLg} />;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleHomeChange || $[16] !== homeVal) {
    t8 = <NumberStepper value={homeVal} onChange={handleHomeChange} orientation="vertical" iconType="caret" min={0} max={20} buttonShape="rounded" styles={stepperStylesLg} />;
    $[15] = handleHomeChange;
    $[16] = homeVal;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-3xl font-black text-(--background-text-color-muted)">-</span>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== awayVal || $[20] !== handleAwayChange) {
    t10 = <NumberStepper value={awayVal} onChange={handleAwayChange} orientation="vertical" iconType="caret" min={0} max={20} buttonShape="rounded" styles={stepperStylesLg} />;
    $[19] = awayVal;
    $[20] = handleAwayChange;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = opponent.shortName || opponent.name;
  const t12 = opponent.assets?.logo;
  let t13;
  if ($[22] !== t12) {
    t13 = <TeamLogo src={t12} size="xl2" />;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t11 || $[25] !== t13) {
    t14 = <EntityDisplay name={t11} image={t13} imagePosition="left" styles={awayTeamStylesLg} />;
    $[24] = t11;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t10 || $[28] !== t14 || $[29] !== t7 || $[30] !== t8) {
    t15 = <div className="hidden sm:flex items-center justify-center gap-4 lg:gap-6 mb-8">{t7}{t8}{t9}{t10}{t14}</div>;
    $[27] = t10;
    $[28] = t14;
    $[29] = t7;
    $[30] = t8;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = team.shortName || team.name;
  const t17 = team.assets?.logo;
  let t18;
  if ($[32] !== t17) {
    t18 = <TeamLogo src={t17} size="lg" />;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t16 || $[35] !== t18) {
    t19 = <EntityDisplay name={t16} image={t18} imagePosition="left" truncate={true} styles={teamStylesSm} />;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== handleHomeChange || $[38] !== homeVal) {
    t20 = <NumberStepper value={homeVal} onChange={handleHomeChange} orientation="horizontal" iconType="chevron" min={0} max={20} size="sm" buttonShape="rounded" styles={stepperStylesSm} />;
    $[37] = handleHomeChange;
    $[38] = homeVal;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== t19 || $[41] !== t20) {
    t21 = <div className="flex items-center justify-between gap-3">{t19}{t20}</div>;
    $[40] = t19;
    $[41] = t20;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  const t22 = opponent.shortName || opponent.name;
  const t23 = opponent.assets?.logo;
  let t24;
  if ($[43] !== t23) {
    t24 = <TeamLogo src={t23} size="lg" />;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t22 || $[46] !== t24) {
    t25 = <EntityDisplay name={t22} image={t24} imagePosition="left" truncate={true} styles={teamStylesSm} />;
    $[45] = t22;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== awayVal || $[49] !== handleAwayChange) {
    t26 = <NumberStepper value={awayVal} onChange={handleAwayChange} orientation="horizontal" iconType="chevron" min={0} max={20} size="sm" buttonShape="rounded" styles={stepperStylesSm} />;
    $[48] = awayVal;
    $[49] = handleAwayChange;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t25 || $[52] !== t26) {
    t27 = <div className="flex items-center justify-between gap-3">{t25}{t26}</div>;
    $[51] = t25;
    $[52] = t26;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== t21 || $[55] !== t27) {
    t28 = <div className="sm:hidden flex flex-col gap-3 mb-8">{t21}{t27}</div>;
    $[54] = t21;
    $[55] = t27;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== hasError || $[58] !== labels.predictionError) {
    t29 = hasError && <div className="mb-6 p-3 rounded-lg bg-red-500/20 border border-red-500/30 text-center"><p className="text-sm font-medium text-(--background-text-color)">{labels.predictionError}</p></div>;
    $[57] = hasError;
    $[58] = labels.predictionError;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] !== labels.backButton || $[61] !== onBack) {
    t30 = <button type="button" onClick={onBack} className="px-6 py-2 sm:px-8 sm:py-3 rounded-full text-sm sm:text-base text-(--background-text-color) font-semibold border border-white/30 sm:border-2 hover:bg-white/10 transition-colors cursor-pointer">← {labels.backButton}</button>;
    $[60] = labels.backButton;
    $[61] = onBack;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  const t31 = `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})`;
  let t32;
  if ($[63] !== t31) {
    t32 = {
      background: t31,
      boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
    };
    $[63] = t31;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  const t33 = isSubmitting ? labels.submitting : labels.submitButton;
  let t34;
  if ($[65] !== isSubmitting || $[66] !== t32 || $[67] !== t33) {
    t34 = <button type="submit" disabled={isSubmitting} className="px-10 py-3 rounded-full text-(--background-text-color) font-bold disabled:opacity-50 disabled:cursor-not-allowed transition-all cursor-pointer hover:scale-105" style={t32}>{t33}</button>;
    $[65] = isSubmitting;
    $[66] = t32;
    $[67] = t33;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t30 || $[70] !== t34) {
    t35 = <div className="flex flex-col-reverse sm:flex-row justify-center gap-4">{t30}{t34}</div>;
    $[69] = t30;
    $[70] = t34;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  let t36;
  if ($[72] !== onSubmit || $[73] !== t15 || $[74] !== t28 || $[75] !== t29 || $[76] !== t3 || $[77] !== t35) {
    t36 = <form onSubmit={onSubmit} className="max-w-2xl mx-auto">{t3}{t15}{t28}{t29}{t35}</form>;
    $[72] = onSubmit;
    $[73] = t15;
    $[74] = t28;
    $[75] = t29;
    $[76] = t3;
    $[77] = t35;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  return t36;
};